import { GridModel } from '@frontend/sports/grid/core/feature/model';
import { createFeatureSelector } from '@ngrx/store';

export interface IGridState {
    [key: string]: GridModel;
}

export const gridInitialState: IGridState = {};

export const gridStateKey = 'grid';

export interface IGridRootState {
    grid: IGridState;
}

export const gridStateSelector = createFeatureSelector<IGridState>(gridStateKey);
